import { useState, useCallback, useEffect } from 'react';
export var useSectionEditing = function useSectionEditing(_ref) {
  var section = _ref.section,
      sectionLabel = _ref.sectionLabel,
      _ref$readonly = _ref.readonly,
      readonly = _ref$readonly === void 0 ? false : _ref$readonly,
      onUpdateSection = _ref.onUpdateSection;

  var _useState = useState(null),
      editingField = _useState[0],
      setEditingField = _useState[1];

  var _useState2 = useState(false),
      descriptionHovered = _useState2[0],
      setDescriptionHovered = _useState2[1];

  var _useState3 = useState((section === null || section === void 0 ? void 0 : section.title) || ''),
      localTitle = _useState3[0],
      setLocalTitle = _useState3[1];

  var _useState4 = useState((section === null || section === void 0 ? void 0 : section.description) || ''),
      localDescription = _useState4[0],
      setLocalDescription = _useState4[1]; // Initialize local values when section changes


  useEffect(function () {
    setLocalTitle((section === null || section === void 0 ? void 0 : section.title) || '');
    setLocalDescription((section === null || section === void 0 ? void 0 : section.description) || '');
  }, [section === null || section === void 0 ? void 0 : section.title, section === null || section === void 0 ? void 0 : section.description]);
  var handleTitleFocus = useCallback(function () {
    if (readonly) return;
    var defaultTitleText = "".concat((sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.defaultSectionTitle) || '');

    if (localTitle === defaultTitleText) {
      setLocalTitle('');
    }

    setEditingField('title');
  }, [readonly, localTitle, sectionLabel]);
  var handleTitleBlur = useCallback(function () {
    if (readonly) return;
    var defaultTitleText = "".concat((sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.defaultSectionTitle) || '');

    if (!localTitle.length) {
      setLocalTitle(defaultTitleText);
      onUpdateSection === null || onUpdateSection === void 0 ? void 0 : onUpdateSection('title', defaultTitleText);
    } else {
      onUpdateSection === null || onUpdateSection === void 0 ? void 0 : onUpdateSection('title', localTitle);
    }

    setEditingField(null);
  }, [readonly, localTitle, sectionLabel, onUpdateSection]);
  var handleTitleKeyDown = useCallback(function (e) {
    if (readonly) return;

    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      var defaultTitleText = "".concat((sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.defaultSectionTitle) || '');

      if (!localTitle.length) {
        setLocalTitle(defaultTitleText);
        onUpdateSection === null || onUpdateSection === void 0 ? void 0 : onUpdateSection('title', defaultTitleText);
      } else {
        onUpdateSection === null || onUpdateSection === void 0 ? void 0 : onUpdateSection('title', localTitle);
      }

      setEditingField(null); // Blur the textarea after applying changes

      e.currentTarget.blur();
    }
  }, [readonly, localTitle, sectionLabel, onUpdateSection]);
  var handleTitleChange = useCallback(function (e) {
    setLocalTitle(e.target.value);
  }, []);
  var handleDescriptionClick = useCallback(function () {
    if (readonly) return;
    setEditingField('description');
  }, [readonly]);
  var handleDescriptionSave = useCallback(function () {
    if (readonly) return;
    onUpdateSection === null || onUpdateSection === void 0 ? void 0 : onUpdateSection('description', localDescription);
    setEditingField(null);
  }, [readonly, localDescription, onUpdateSection]);
  var handleDescriptionCancel = useCallback(function () {
    if (readonly) return;
    setLocalDescription((section === null || section === void 0 ? void 0 : section.description) || '');
    setEditingField(null);
  }, [readonly, section]);
  var handleDescriptionChange = useCallback(function (value) {
    setLocalDescription(value);
  }, []);
  return {
    editingField: editingField,
    descriptionHovered: descriptionHovered,
    localTitle: localTitle,
    localDescription: localDescription,
    setDescriptionHovered: setDescriptionHovered,
    handleTitleFocus: handleTitleFocus,
    handleTitleBlur: handleTitleBlur,
    handleTitleChange: handleTitleChange,
    handleTitleKeyDown: handleTitleKeyDown,
    handleDescriptionClick: handleDescriptionClick,
    handleDescriptionSave: handleDescriptionSave,
    handleDescriptionCancel: handleDescriptionCancel,
    handleDescriptionChange: handleDescriptionChange,
    isTitleEditing: editingField === 'title',
    isDescriptionEditing: editingField === 'description'
  };
};